import { templates } from 'js/src/data/templates/templates-reducers';

/* MODULE EXPORTS */
export * from 'js/src/data/templates/templates-operations';
export * from 'js/src/data/templates/templates-selectors';
export * from 'js/src/data/templates/templates-types';
export * from 'js/src/data/templates/templates-actions';

export default templates;
